__turbopack_context__.v({
  "Large": "Lockup-module-scss-module__Ytrslq__Large",
  "Medium": "Lockup-module-scss-module__Ytrslq__Medium",
  "Small": "Lockup-module-scss-module__Ytrslq__Small",
  "X-Large": "Lockup-module-scss-module__Ytrslq__X-Large",
  "XX-Large": "Lockup-module-scss-module__Ytrslq__XX-Large",
  "copy": "Lockup-module-scss-module__Ytrslq__copy",
  "ctas": "Lockup-module-scss-module__Ytrslq__ctas",
  "eyebrow": "Lockup-module-scss-module__Ytrslq__eyebrow",
  "hasLongWord": "Lockup-module-scss-module__Ytrslq__hasLongWord",
  "headline": "Lockup-module-scss-module__Ytrslq__headline",
  "icon": "Lockup-module-scss-module__Ytrslq__icon",
  "root": "Lockup-module-scss-module__Ytrslq__root",
});
